export enum OfficesContainerTypes {
  OfficesModalsFacade = 'OfficesModalsFacade',
}
